import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Mantine ships its styles as real CSS. Order matters: core first, then the
// packages that extend it.
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/charts/styles.css';
import './styles.css';

import { App } from './App.js';
import { installPrompt } from './offline/install.js';

// Before the first render: Chrome fires `beforeinstallprompt` once per page
// load, usually long before anyone opens Indstillinger → Mobil-app.
installPrompt.listen(window);

const container = document.getElementById('root');
if (container === null) {
  // index.html and this file disagreeing is a build problem, and a silent no-op
  // would present as a blank page with nothing in the console.
  throw new Error('No #root element: index.html and main.tsx disagree.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
